import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ProductSlider from './product-slider-v1';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

// import parse from 'html-react-parser';
import Amenities from './amenities';
import Reserve from './reservation';

const initialStateOwner = {
  full_name: '...loading',
  description: null
}
const ListingDetail = ({ data, carrouselLinks }) => {

  let publicUrl = process.env.PUBLIC_URL + '/'
  const [ownerData, setOwnerData] = useState(initialStateOwner)

  useEffect(() => {
    if (data?.owner) {
      fetch(`https://f3mw4bb5.directus.app/items/owners/${data.owner}`)
        .then(response => response.json())
        .then(result => {
          setOwnerData(result.data)
        })
    }
  }, [data])

  if (!data) {
    return null
  }

  return (
    <div className="ltn__shop-details-area pb-10 pt-20">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-12">
            <div className="ltn__shop-details-inner ltn__page-details-inner mb-60">
              <div className="ltn__blog-meta">
                <ul>
                  <li className="ltn__blog-category">
                    <Link to="#">Featured</Link>
                  </li>
                  <li className="ltn__blog-category">
                    <Link className="bg-orange" to="#">For Rent</Link>
                  </li>
                  {/* <li className="ltn__blog-date">
                    <i className="far fa-calendar-alt" />May 19, 2021
                  </li>
                  <li>
                    <Link to="#"><i className="far fa-comments" />35 Comments</Link>
                  </li> */}
                </ul>
              </div>
              <h1>{data.name}</h1>
              <label><span className="ltn__secondary-color"><i className="flaticon-pin" /></span> {data.address}</label>
              <ProductSlider photos={carrouselLinks} />
              {data?.description && (
                <>
                  <h4 className="title-2">Description</h4>
                  <p>
                    {data.description}
                  </p>
                </>
              )}
              <h4 className="title-2">Property Detail</h4>
              <div className="property-detail-info-list section-bg-1 clearfix mb-60">
                <ul>
                  {/* <li><label>Property ID:</label> <span>HZ29</span></li> */}
                  <li><label>Home Area: </label> <span>{data.home_area} m2</span></li>
                  <li><label>Rooms:</label> <span>{data.rooms}</span></li>
                  <li><label>Baths:</label> <span>{data.baths}</span></li>
                  <li><label>Year built:</label> <span>{data.year_built}</span></li>
                </ul>
                <ul>
                  <li><label>Property ID:</label> <span>{data.id}</span></li>
                  {/* <li><label>Lot dimensions:</label> <span>120 sqft</span></li> */}
                  <li><label>Beds:</label> <span>{data.beds}</span></li>
                  <li><label>Price:</label>
                    <span>
                      {/* TODO add format */}
                      ${data.price}/{data.rental_recurrence}
                    </span>
                  </li>
                  {/* <li><label>Property Status:</label> <span>For Sale</span></li> */}
                </ul>
              </div>
              {/* <h4 className="title-2">Facts and Features</h4>
              <div className="property-detail-feature-list clearfix mb-45">
                <ul>
                  <li>
                    <div className="property-detail-feature-list-item">
                      <i className="flaticon-double-bed" />
                      <div>
                        <h6>Living Room</h6>
                        <small>20 x 16 sq feet</small>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="property-detail-feature-list-item">
                      <i className="flaticon-double-bed" />
                      <div>
                        <h6>Garage</h6>
                        <small>20 x 16 sq feet</small>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="property-detail-feature-list-item">
                      <i className="flaticon-double-bed" />
                      <div>
                        <h6>Dining Area</h6>
                        <small>20 x 16 sq feet</small>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="property-detail-feature-list-item">
                      <i className="flaticon-double-bed" />
                      <div>
                        <h6>Bedroom</h6>
                        <small>20 x 16 sq feet</small>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="property-detail-feature-list-item">
                      <i className="flaticon-double-bed" />
                      <div>
                        <h6>Bathroom</h6>
                        <small>20 x 16 sq feet</small>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="property-detail-feature-list-item">
                      <i className="flaticon-double-bed" />
                      <div>
                        <h6>Gym Area</h6>
                        <small>20 x 16 sq feet</small>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="property-detail-feature-list-item">
                      <i className="flaticon-double-bed" />
                      <div>
                        <h6>Garden</h6>
                        <small>20 x 16 sq feet</small>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="property-detail-feature-list-item">
                      <i className="flaticon-double-bed" />
                      <div>
                        <h6>Parking</h6>
                        <small>20 x 16 sq feet</small>
                      </div>
                    </div>
                  </li>
                </ul>
              </div> */}
              {/* <h4 className="title-2">From Our Gallery</h4>
              <div className="ltn__property-details-gallery mb-30">
                <div className="row">
                  <div className="col-md-6">
                    <a href={`https://f3mw4bb5.directus.app/assets/${data.images['740x352']}`} data-rel="lightcase:myCollection">
                      <img className="mb-30" src={`https://f3mw4bb5.directus.app/assets/${data.images['740x352']}`} alt="" />
                    </a>
                    <a href={`https://f3mw4bb5.directus.app/assets/${data?.images['740x426']}`} data-rel="lightcase:myCollection">
                      <img className="mb-30" src={`https://f3mw4bb5.directus.app/assets/${data?.images['740x426']}`} alt="" />
                    </a>
                  </div>
                  <div className="col-md-6">
                    <a href={`https://f3mw4bb5.directus.app/assets/${data.images['740x834']}`} data-rel="lightcase:myCollection">
                      <img className="mb-30" src={`https://f3mw4bb5.directus.app/assets/${data.images['740x834']}`} alt="" />
                    </a>
                  </div>
                </div>
              </div> */}
              <h4 className="title-2 mb-10">Amenities</h4>
              <div className="property-details-amenities mb-60">
                <Amenities amenities={data.amenities} />
              </div>
              {data?.iframe_src_map && <h4 className="title-2">Location</h4>}
              <div className="property-details-google-map mb-60">
                <iframe
                  title="map"
                  src={data.iframe_src_map}
                  width="100%"
                  height="100%"
                  frameBorder={0}
                  allowFullScreen
                  aria-hidden="false"
                  tabIndex={0}
                />
              </div>
              {/* APARTMENTS PLAN AREA START */}
              {/* APARTMENTS PLAN AREA END */}
              {data.url_video && (
                <>
                  <h4 className="title-2">Property Video</h4>
                  <div className="ltn__video-bg-img ltn__video-popup-height-500 bg-overlay-black-50 bg-image mb-60" data-bs-bg={publicUrl + "assets/img/others/5.jpg"}>
                    <a className="ltn__video-icon-2 ltn__video-icon-2-border---" href="https://www.youtube.com/embed/eWUxqVFBq74?autoplay=1&showinfo=0" data-rel="lightcase:myCollection">
                      <i className="fa fa-play" />
                    </a>
                  </div>
                </>
              )}
               <Reserve propertyId={data.id} />
            </div>
          </div>
          <div className="col-lg-4">
            <aside className="sidebar ltn__shop-sidebar ltn__right-sidebar---">
              {/* Author Widget */}
              <div className="widget ltn__author-widget">
                <div className="ltn__author-widget-inner text-center">
                  <img
                    src={ownerData?.avatar
                      ? `https://f3mw4bb5.directus.app/assets/${ownerData?.avatar}`
                      : `${publicUrl}assets/img/team/4.jpg`
                    }
                    alt="" />
                  <h5>{ownerData.full_name}</h5>
                  {/* <div className="product-ratting">
                    <ul>
                      <li><a href="#"><i className="fas fa-star" /></a></li>
                      <li><a href="#"><i className="fas fa-star" /></a></li>
                      <li><a href="#"><i className="fas fa-star" /></a></li>
                      <li><a href="#"><i className="fas fa-star-half-alt" /></a></li>
                      <li><a href="#"><i className="far fa-star" /></a></li>
                      <li className="review-total"> <a href="#"> ( 1 Reviews )</a></li>
                    </ul>
                  </div> */}
                  <p>{ownerData.description}</p>
                  <div className="ltn__social-media">
                    <ul>
                      {ownerData?.social_networks?.facebook && (
                        <li><a href={ownerData.social_networks.facebook} title="Facebook"><i className="fab fa-facebook-f" /></a></li>
                      )}
                      {ownerData?.social_networks?.twitter && (
                        <li><a href={ownerData.social_networks.twitter} title="Twitter"><i className="fab fa-twitter" /></a></li>
                      )}
                      {/* <li><a href="#" title="Linkedin"><i className="fab fa-linkedin" /></a></li>
                      <li><a href="#" title="Youtube"><i className="fab fa-youtube" /></a></li> */}
                    </ul>
                  </div>
                </div>
              </div>
              {/* Banner Widget */}
              {/* <div className="widget ltn__banner-widget d-none go-top">
                <Link to="/shop"><img src={publicUrl + "assets/img/banner/2.jpg"} alt="#" /></Link>
              </div> */}
            </aside>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ListingDetail
